import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const PreviewIcon = ({
  width=28,
  height=16,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 16"
      fill="none"
    >
      <path
        d="M14.306 2.286c4.884 0 8.438 2.786 10.301 4.696a.928.928 0 0 1 .047 1.245c-1.82 2.184-5.391 5.487-10.348 5.487-4.571 0-8.29-3.309-10.268-5.523a.932.932 0 0 1 .032-1.283c1.912-1.916 5.46-4.622 10.236-4.622zm0-2.286C7.06 0 2.319 5.252.97 6.958a.873.873 0 0 0-.015 1.07C2.335 9.902 7.361 16 14.305 16c7.516 0 12.154-6.155 13.374-7.998a.864.864 0 0 0-.035-1.01C26.368 5.32 21.72 0 14.306 0zm-.017 3.429a4.57 4.57 0 1 0-.002 9.141 4.57 4.57 0 0 0 .002-9.141zm-.005 4.57a1.653 1.653 0 0 1-2.336-2.336 1.653 1.653 0 0 1 2.336 2.336z"
        fill={strokeColor}
      />
    </svg>
  )
}

export default PreviewIcon
